import React, { forwardRef } from 'react';
import MuiInput from './MuiInput';

/**
 * Input component that wraps MUI TextField
 * This component maintains the same API as the original Input component
 * but uses Material-UI under the hood
 */
const Input = forwardRef(({
  type = 'text',
  label,
  placeholder,
  error,
  helperText,
  required = false,
  disabled = false,
  icon,
  className = '',
  id,
  name,
  value,
  defaultValue,
  onChange,
  onBlur,
  onFocus,
  ...props
}, ref) => {
  return (
    <MuiInput
      ref={ref}
      type={type}
      label={label}
      placeholder={placeholder}
      error={error}
      helperText={helperText}
      required={required}
      disabled={disabled}
      icon={icon}
      className={className}
      id={id}
      name={name}
      value={value}
      defaultValue={defaultValue}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      {...props}
    />
  );
});

Input.displayName = 'Input';

export default Input;